angular.module 'zc.masterApi'

.factory "MasterCampaignSegmentStats", ($q, FacadeV2) ->


  class MasterCampaignSegmentStats

    @find: (query, opts={}) ->
      $q (resolve, reject) ->
        query ||= {}
        unless query._id or (query.apikey and query.start_at)
          return reject "no _id or apikey/start_at provided"

        FacadeV2.request "/master/campaign_segment_stats/daily",
          params:
            match: query
            sort: '-start_at'
            limit: opts.limit || undefined
        .then (res) ->
          if res.status != 200
            return reject res.data.error
          resolve res.data

    @aggregate: (paths, query) ->
      params = {}
      params.match = query.match
      params.pipeline = query.pipeline

      FacadeV2.request "/master/campaign_segment_stats/#{paths.dimension}/aggregate", {
        params: params
      }
      .then (res) ->
        res.data

  MasterCampaignSegmentStats



// WEBPACK FOOTER //
// ./src/master_admin_modules/master_api/facade/master_campaign_segment_stats.service.coffee